module.exports = __webpack_public_path__ + "static/media/Introl.2d3e68c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/Introl.mp4
// module id = ZAKr
// module chunks = 0